/**
 * branding.defaults.ts — generic FirePCR fallback values.
 *
 * These values are intentionally generic — every deployment should override
 * them via VITE_* environment variables set in Vercel per project.
 */
import type { BrandConfig } from './config.js'

export const brandDefaults: BrandConfig = {
  // ── Company Identity ────────────────────────────────────────────────────
  companyName:        'FirePCR',
  companyLegal:       'FirePCR',
  appName:            'FirePCR',
  appBrand:           'FirePCR',
  domain:             'firepcr.com',
  supportEmail:       'support@firepcr.com',
  notificationsEmail: 'FirePCR <notifications@firepcr.com>',

  // ── Logo & Assets ───────────────────────────────────────────────────────
  logoUrl: '/firepcr-logo.png',

  // ── NEMSIS / EMS Identifiers ────────────────────────────────────────────
  // Agency-specific — must be set via env vars per deployment.
  nemsisAgencyId:        '',
  nemsisStateAgencyId:   '',
  nemsisStateCode:       '',
  nemsisLemsa:           '',
  nemsisSoftware:        'FirePCR v1.0',
  nemsisSoftwareCreator: 'FirePCR',

  // ── Unit Naming Conventions ─────────────────────────────────────────────
  unitPrefixes: {
    ambulance: 'AMB',
    medUnit:   'MSU',
    rems:      'REMS',
    warehouse: 'WH',
    truck:     'TRK',
  },

  // ── AI Assistant ────────────────────────────────────────────────────────
  assistantName:    'Assistant',
  assistantEmoji:   '🔥',
  assistantContext: 'You are an AI assistant for a wildfire medical operations team.',

  // ── Legal / Consent Forms ───────────────────────────────────────────────
  consentEntity: 'FirePCR',
  hipaaEntity:   'FirePCR',

  // ── Scheduling / Ops ────────────────────────────────────────────────────
  schedulerContext: 'You are a scheduling assistant for a wildfire medical operations team.',

  // ── Push Notifications ──────────────────────────────────────────────────
  vapidContact: 'mailto:support@firepcr.com',

  // ── Documents ───────────────────────────────────────────────────────────
  handbookUrl: '',  // must be set per deployment
}
